import React from 'react';
import { connect } from 'react-redux';
import { Row, Col, ControlLabel } from 'react-bootstrap';
import { List } from 'immutable';
import 'react-widgets/lib/less/react-widgets.less';
import {
  FormControl,
  Button,
  Checkbox,
} from '../../../form/FormControls.jsx';
import RefPicker from '../../simple/select/DictPicker.jsx';
import RequiredFormControl from '../../../form/RequiredFormControl.jsx';
import { MainComponentBox, FormGroupWValidation as FormGroup } from '../../../../util/util.jsx';

import { Edit as DictEdit, mapDispatchToProps } from '../../simple/Edit';

import { REF_NAME, REF_PATH } from './Const';
import EditWarningRow from '@/component/dict/simple/EditWarningRow';

class Edit extends DictEdit {
  constructor(props) {
    super(props);
    this.init = this.init.bind(this);
    this.setRefPath(REF_PATH);
    this.setRefName(REF_NAME);
  }
  componentWillMount() {
    if (super.componentWillMount) {
      super.componentWillMount();
    }
    this.init(this.props);
  }
  componentWillReceiveProps(props) {
    if (super.componentWillReceiveProps) {
      super.componentWillReceiveProps(props);
    }
    this.init(props);
  }
  init(props) {
    if (props.refObject && props.refObject.get('predefine')) {
      const predefine = JSON.parse(props.refObject.get('predefine'));
      this.setState({ predefine });
    }
  }
  getLabel = () => {
    if (this.props.params.refId === 'new') {
      return <div className={'edit-reference-header'}>New Expense type</div>;
    }
    return <div className={'edit-reference-header'}>Edit Expense type</div>;
  }

  render() {
    let component;
    if (this.props.params.refId == 'new' || this.state.ref) {
      component = (<div>
        <form id="refForm" onSubmit={this.onSubmit}>
          <input
            className="hide" type="text" name="predefine"
            value={this.state.ref ? this.state.ref.get('predefine') : undefined} readOnly
          />
          <EditWarningRow />
          <MainComponentBox>
            <Row className={'reference-edit-panel'}>
              <Col xs={12} md={6} lg={6}>
                {this.getLabel()}
                <FormGroup id="name">
                  <ControlLabel style={{ height: 'auto' }}>Name</ControlLabel>
                  <RequiredFormControl
                    component={FormControl}
                    name="name"
                    type="text"
                    defaultValue={this.state.ref ? this.state.ref.get('name') : undefined}
                    disabled={this.state.predefine
                      ? this.state.predefine.name != undefined
                      : false
                    }
                  />
                </FormGroup>

                <FormGroup id="isTransport">
                  <Checkbox
                    name="isTransport"
                    data-predefined={this.state.predefine
                      ? this.state.predefine.isTransport != undefined
                      : false
                    }
                    defaultChecked={this.state.ref ? this.state.ref.get('isTransport') : false}
                    disabled={this.state.predefine
                      ? this.state.predefine.isTransport != undefined
                      : false
                    }
                  >
                    Transport
                  </Checkbox>
                </FormGroup>
                <FormGroup id="isSale">
                  <Checkbox
                    name="isSale"
                    data-predefined={this.state.predefine
                      ? this.state.predefine.isSale != undefined
                      : false
                    }
                    defaultChecked={this.state.ref ? this.state.ref.get('isSale') : false}
                    disabled={this.state.predefine
                      ? this.state.predefine.isSale != undefined
                      : false
                    }
                  >
                    Sale
                  </Checkbox>
                </FormGroup>
                <FormGroup id="isPurchase">
                  <Checkbox
                    name="isPurchase"
                    data-predefined={this.state.predefine
                      ? this.state.predefine.isPurchase != undefined
                      : false
                    }
                    defaultChecked={this.state.ref ? this.state.ref.get('isPurchase') : false}
                    disabled={this.state.predefine
                      ? this.state.predefine.isPurchase != undefined
                      : false}
                  >
                    Purchase
                  </Checkbox>
                </FormGroup>

                <FormGroup id="common">
                  <Checkbox
                    name="common"
                    data-predefined={this.state.predefine
                      ? this.state.predefine.common != undefined
                      : false
                    }
                    defaultChecked={this.state.ref ? this.state.ref.get('common') : false}
                    disabled={this.state.predefine
                      ? this.state.predefine.common != undefined
                      : false}
                  >
                    Common
                  </Checkbox>
                </FormGroup>

                <FormGroup id="expensesCategory">
                  <ControlLabel>Expense category</ControlLabel>
                  <RefPicker
                    dict="expensecategory" name="expensesCategory"
                    defaultValue={this.state.ref ? this.state.ref.get('expensesCategory') : null}
                  />
                </FormGroup>
                <Button
                  id="saveButton"
                  type="submit" bsStyle="primary" disabled={this.props.saving}
                >
                  {this.props.params.refId === 'new' ? 'Add' : 'Save'}
                </Button>
                <Button id="cancelButton" bsStyle="gray" onClick={this.onCancel}>Cancel</Button>
                <FormControl
                  name="id" type="id" style={{ display: 'none' }}
                  defaultValue={this.state.ref ? this.state.ref.get('id') : undefined}
                />
              </Col>
            </Row>
          </MainComponentBox>
        </form>
      </div>);
    } else {
      component = <div></div>;
    }
    return component;
  }
}

export default connect((state, props) =>
  ({
    saving: state.getIn(['allaround', 'saving'], false),
    refObject: state
      .getIn(['references', 'simple', REF_PATH], new List())
      .find(r => r.get('id') == props.params.refId),
  }),
mapDispatchToProps(REF_NAME, REF_PATH),
)(Edit);
